import React, { Component } from 'react';
import { Row, Col, Button, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ContentWrapper from '../../components/Layout/ContentWrapper';

class ConfirmActionModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {

    };
    this.caseAction = this.caseAction.bind(this);
  }

  componentDidMount() {

  }

  componentWillReceiveProps() {

  }

  caseAction() {
    switch (this.props.case) {
      case 'removeItem':
        this.props.removeItem(this.props.index);
      case 'clearForm':
        this.props.clearForm();
    }
    this.props.closeC();
  }

  renderPrompt() {
    switch (this.props.case) {
      case 'confirmProductRepeat':
        return (
          <span>
            <Translate value="duplicate_product_promotion" />
          </span>
        );
      case 'convertUneven':
        return (
          <span>
            <Translate value="products_do_not_convert_evenly" />
          </span>
        );
      case 'removeItem':
        return (
          <span>
            <Translate value="Are_you_sure_you_want_to_remove_item?" />
          </span>
        );
      case 'clearForm':
        return (
          <span>
            <Translate value="Are_you_sure_you_want_to_clear_order?" />
          </span>
        );
      case 'noPermission':
        return (
          <span>
            <Translate value="You_do_not_have_permission" />
          </span>
        );
      case 'itemOutOfStock':
        return (
          <span>
            <Translate value="Item_is_out_of_stock" />
          </span>
        );
      case 'itemAlreadyInOrder':
        return (
          <span>
            <Translate value="msg_item_already_in_sales_order" />
          </span>
        );
      case 'addingDuplicate':
        return (
          <span>
            <h4><Translate value="msg_add_duplicate_item" /></h4>
          </span>
        );
      case 'completeSheet':
        return (
          <span>
            <Translate value="are_you_sure_you_want_to_complete_this_sheet?" />
            &nbsp;<Translate value="you_will_not_be_able_to_create_new_receivings_after" />
          </span>
        );
      case 'quantityZero':
        return (
          <span>
            <Translate value="value_has_been_left_0_Continue" />
          </span>
        );
      case 'noCustomerChosen':
        return (
          <span>
            <Translate value="please_choose_customer_first" />
          </span>
        );
      case 'zeroQuantity':
        return (
          <span>
            <h3><Translate value="quantity_cannot_have_a_zero_value" /></h3>
            {
              this.props.zeroArray.map((obj) => {
                return (
                  <Row>
                    <Col xs={6} xsOffset={3} className="centerStyle">
                      {obj.Name}
                    </Col>
                  </Row>
                );
              })
            }
          </span>
        );
      case 'zeroWeight':
        return (
          <span>
            <h3><Translate value="weight(s)_cannot_have_a_zero_value" /></h3>
          </span>
        );
      case 'belowRefPrice':
        return (
          <span>
            <h3><Translate value="your_current_sale_price_is_below_lowest_sale_price" /></h3>
            {/* <h3><Translate value="the_reference_is" /> <span className="warning">{this.props.rowEdited.RefPrice}</span></h3> */}
            <h3><Translate value="the_reference_is" /> <span className="warning">{this.props.rowEdited.LowestSalePrice}</span></h3>
            <h3><Translate value="your_current_sale_price_is" /> <span className="warning">{this.props.newPrice}</span></h3>
            <h3><Translate value="want_to_sale_at_current_price" />?</h3>
          </span>
        );
      case 'belowLowestSalePrice':
        return (
          <span>
            <h3><Translate value="your_current_sale_price_is_below_lowest_sale_price" /></h3>
            <h3><Translate value="the_lowest_sale_price_is" /> <span className="warning">{this.props.lowestSalePrice}</span></h3>
            <h3><Translate value="your_current_sale_price_is" /> <span className="warning">{this.props.currentPrice}</span></h3>
            <h3><Translate value="want_to_sale_at_current_price" />?</h3>
          </span>
        );
      case 'belowLowestSalePriceAndDuplicate':
        return (
          <span>
            <h3><Translate value="msg_add_duplicate_item" /></h3>
            <br />
            <h3><Translate value="your_current_sale_price_is_below_lowest_sale_price" /></h3>
            <h3><Translate value="the_lowest_sale_price_is" /> <span className="warning">{this.props.lowestSalePrice}</span></h3>
            <h3><Translate value="your_current_sale_price_is" /> <span className="warning">{this.props.currentPrice}</span></h3>
            <h3><Translate value="want_to_sale_at_current_price" />?</h3>
          </span>
        );
      case 'confirmPassword':
        return (
          <span>
            <h3><Translate value="type_in_your_password" /></h3>
          </span>
        );
      case 'editSOPermission':
        return (
          <span>
            <h3><Translate value="msg_ask_for_manager_login" /></h3>
          </span>
        );
      case 'editRecPermission':
        return (
          <span>
            <h3><Translate value="msg_ask_for_manager_login" /></h3>
          </span>
        );
      case 'editDeliveryFeeRate':
        return (
          <span>
            <h3><Translate value="msg_ask_for_manager_login" /></h3>
          </span>
        );
      case 'voidStatus':
        return (
          <span>
            <h3>
              {
                (this.props.apNum) ?
                  <div>
                    <Translate value={this.props.voidStatus} />
                    <span>{this.props.apNum}</span>
                    <Translate value={this.props.voidStatusEnd} />
                  </div>
                : <Translate value={this.props.voidStatus} />
              }
            </h3>
          </span>
        );
      case 'chooseGroup':
        return (
          <span>
            <h3><Translate value="please_choose_customers_group" /></h3>
          </span>
        );
      case 'chooseTimePeriod':
        return (
          <span>
            <h3><Translate value="please_choose_start_date_and_end_date" /></h3>
          </span>
        );
      case 'chooseItemTwo':
        return (
          <span>
            <h3><Translate value="please_choose_item_b" /></h3>
          </span>
        );
      case 'chooseItemOne':
        return (
          <span>
            <h3><Translate value="please_choose_an_item_for_promotion" /></h3>
          </span>
        );
      case 'zerototalPrice':
        return (
          <span>
            <Translate value="total_price_cannot_be_zero" />
          </span>
        );
      case 'paymentTermMissing':
        return (
          <span>
            <Translate value="select_payment_term_first" />
          </span>
        );
      case 'confirmRefund':
        return (
          <span>
            <Translate value="msg_confirm_refund_order" />
          </span>
        );
      case 'deleteGroup':
        return (
          <span>
            <Translate value="msg_confirm_delete" />
          </span>
        );
      case 'addCustToGroup':
        return (
          <span>
            <Translate value="msg_confirm_add_customer_to_group" />
          </span>
        );
      case 'groupChange':
        return (
          <span>
            <Translate value="msg_confirm_change_group_without_save_products" />
          </span>
        );
      case 'chooseProduct':
        return (
          <span>
            <Translate value="you_must_select_an_item" />
          </span>
        );
      default:
        return (
          this.props.case || null
        );
    }
  }

  renderButtons() {
    switch (this.props.case) {
      case 'noPermission':
      case 'itemOutOfStock':
      case 'itemAlreadyInOrder':
      case 'noCustomerChosen':
      case 'zeroQuantity':
      case 'zeroWeight':
      case 'quantityZero':
      case 'convertUneven':
      case 'chooseGroup':
      case 'chooseTimePeriod':
      case 'chooseItemTwo':
      case 'chooseItemOne':
      case 'zerototalPrice':
      case 'chooseProduct':
        return (
          <Button bsStyle="primary" className="mt mr" onClick={this.props.closeC}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
        );
      case 'confirmPassword':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><Input type="password" ref={(input) => this.input = input} /></div>
            <div className="col-xs-1 col-xs-offset-5" style={{ marginTop: '50px' }}><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeC(this.input.refs.input.value); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button></div>
          </span>
        );
      case 'editSOPermission':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="username" /></label><Input type="text" ref={(input) => this.inputText = input}/></div>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="password" /></label><Input type="password" ref={(input) => this.inputPassword = input}/></div>
            <div className="col-xs-1 col-xs-offset-5"><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.checkPermission(this.inputText.refs.input.value, this.inputPassword.refs.input.value); }}><em className="fa fa-check" /><Translate value="submit" /></Button></div>
          </span>
        );
      case 'editRecPermission':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="username" /></label><Input type="text" ref={(input) => this.inputText = input}/></div>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="password" /></label><Input type="password" ref={(input) => this.inputPassword = input}/></div>
            <div className="col-xs-1 col-xs-offset-5"><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.checkPermission(this.inputText.refs.input.value, this.inputPassword.refs.input.value); }}><em className="fa fa-check" /><Translate value="confirm" /></Button></div>
          </span>
        );
      case 'editDeliveryFeeRate':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="username" /></label><Input type="text" ref={(input) => this.inputText = input}/></div>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="password" /></label><Input type="password" ref={(input) => this.inputPassword = input}/></div>
            <div className="col-xs-1 col-xs-offset-5"><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.checkPermission(this.inputText.refs.input.value, this.inputPassword.refs.input.value); }}><em className="fa fa-check" /><Translate value="confirm" /></Button></div>
          </span>
        );
      case 'addingDuplicate':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.caseAction(); this.props.closeC(); }}><Translate value="continue" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="cancel" /></Button>
          </span>
        );
      case 'voidStatus':
        return (
          <span />
        );
      case 'completeSheet':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.caseAction(this.props.formProps) }}><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'paymentTermMissing':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeC(); }}><Translate value="Confirm" /></Button>
          </span>
        );
      case 'confirmRefund':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.handleRefundConfirm(); this.props.closeConfirmRefund(); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeConfirmRefund(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'belowRefPrice':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.updatePrice(); this.props.closeC(); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      default:
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.caseAction(); this.props.closeC(); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        )
    }
  }

  render() {
    const { closeC, checkPasswordFailure, checkPermissionSuccess } = this.props;
    return (
      <ContentWrapper>
        <Row>
          <Col sm={12} className="text-center" style={{ marginTop: '20px' }}>
            {this.renderPrompt()}
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="text-center">
            {this.renderButtons()}
          </Col>
        </Row>
        <br />
        {checkPasswordFailure && <Row className="text-center alert alert-danger"><Translate value="your_password_is_not_correct" /></Row>}
        {checkPermissionSuccess && !checkPermissionSuccess.manager && <Row className="text-center alert alert-danger"><Translate value="no_permission" /></Row>}
      </ContentWrapper>
    );
  }
}

export default ConfirmActionModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/confirmActionModal.jsx